<template>
    <div class="main-container">
        <div class="head-container">
            <div class="form-label">
                <span>所属目录：</span>
            </div>
            <div class="form-input">
                <Select v-model="formParam.catalogId" filterable clearable>
                    <Option v-for="item in catalogList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                </Select>
            </div>
            <div class="form-label">
                <span>名  称：</span>
            </div>
            <div class="form-input">
                <Input v-model="formParam.name"/>
            </div>
            <div class="form-button">
                <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="showModal">添加材料</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="edit(row)">编辑</Button>
                    <Poptip
                        confirm
                        title="确定删除?"
                        @on-ok="remove(row)" placement="top-start" transfer>
                        <Button class="table-button-remove" size="small">删除</Button>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            title="添加材料"
            width="800"
            footer-hide>
            <div>
                <new-materials v-if="modal" :materInfo="formItem" @handleClose="handleCloseModal"></new-materials>
            </div>
        </Modal>
    </div>
</template>

<script>
import {removeMaterialsInfo, queryMaterialsInfoPage, queryMaterialsCatalogList} from "@/api/baseData"
import NewMaterials from "@/components/BaseData/NewMaterials"


export default {
    name: "MaterialsInfo",
    components: {
        NewMaterials,
    },
    data() {
        return {
            formParam: {
                name: '',
                catalogId: '',
                total: 0,
                current: 1,
                size: 10,
            },
            modal: false,
            loading: false,
            columns: [
                {
                    title: '材料名称',
                    key: 'name',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '所属目录',
                    key: 'catalogName',
                    align: 'center',
                },
                {
                    title: '单位',
                    key: 'unitName',
                    align: 'center',
                },
                {
                    title: '材料号',
                    key: 'matNumber',
                    align: 'center',
                },
                {
                    title: '规格',
                    key: 'matSpec',
                    align: 'center',
                },
                {
                    title: '出库价',
                    key: 'sellPrice',
                    align: 'center',
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    width: 180,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 160,
                    align: 'center',
                },
            ],
            tableData: [],
            catalogList: [],
            formItem: {},
        }
    },
    mounted() {
        queryMaterialsCatalogList({}).then((res) => {
            this.catalogList = res.data
        })
        this.onQuery()
    },
    methods: {
        async onQuery() {
            let res = await queryMaterialsInfoPage(this.formParam)
            if (res.data != null) {
                this.tableData = res.data
                this.formParam.current = res.current
                this.formParam.total = res.total
            }
        },
        handleCloseModal(flag) {
            if (flag) {
                this.onQuery()
            }
            this.modal = false
        },
        showModal() {
            this.formItem = {}
            this.modal = true
        },
        async edit(row) {
            this.formItem = row
            this.modal = true
        },
        async remove(row) {
            await removeMaterialsInfo(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: 400px;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
}

.table-container {
    margin: 10px;
}
</style>
